<template>
    <div class="shops">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <Filters @handleFiltersToggle="openedFilters = $event" @setFilter="setFilter" @reset = "resetFilters" :filter-items="filterItems"/>
                </div>
            </div>
            <div>
                <ShopsList v-if="list && list.length" :list="list" :location="location" />
                <div v-cloak v-else-if="emptyState" class="shops__wrapper-emptystate">
                    <EmptyState
                        image="publish-empty-state"
                        title="No shops found"
                        description="Try different search filters."
                    />
                </div>
                <div v-if="loading" class="loading-holder">
                    <Loader />
                </div>
                <button 
                    v-else-if = "total > list.length"
                    class="phiolet_button mx-auto d-block mb-5"
                    id="load-more-cards-homepage"
                    style="height: 48px; padding: 0 30px" @click="loadMore">
                        Load More
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ShopsList from './ShopsList'
import Filters from './Filters/index'
import EmptyState from '../EmptyState'
import {useShopsList, useUserId, useShopsFilters, useRouter} from '../../../core/hooks'
import {onMounted, ref, watch, computed} from '@vue/composition-api'
import Loader from '../../../components/Icons/Loader'
import _ from 'lodash'

export default {
    name: 'ShopsGrid',
    components: {
        Filters,
        ShopsList,
        Loader,
        EmptyState
    },
    props: {
        location: String
    },
    setup(props, {root}){

        const {userId} = useUserId()
        const {list, getList, total, loading} = useShopsList()
        const {filters, setFilter, resetFilters} = useShopsFilters()
        const page = ref(1)

        const openedFilters = ref(false)

        const emptyState = computed(() => (!list || !list.value.length) && (!loading || !loading.value))
        
        const sendDebouncedEvents = _.debounce(() => {
            // use debouncing to send combined filters
            const alexaRankOrder = filters.value.alexaRankOrder === null ? null : (filters.value.alexaRankOrder === true ? 'ASC' : 'DESC')

            const eventFilters = {
                alexaRankOrder,
                categories: filters.value.category.length ? filters.value.category : null,
                monthlySales: filters.value.monthlySales.length ? 
                    filters.value.monthlySales.map(item => {
                        if(item[0] === 230000) {
                            return 'more than 230000'
                        }
                        return item.join('-')
                    }) : null,
                foundTotalResults: total.value,
                loadedPagesCount: page.value
            }

            root.$sendMixpanelEvent('Homepage Shops Filters Triggered', eventFilters)
            eventFilters.monthlySales = eventFilters.monthlySales ? eventFilters.monthlySales.toString() : null
            eventFilters.categories = eventFilters.categories ? eventFilters.categories.toString() : null
            root.$ga.event('Homepage Shops Filters', 'Filters Triggered', eventFilters)

        }, 5000)


        const filterItems = computed(() => {
            const filtersArr = [];
            for (const key in filters.value) {
                if(Array.isArray(filters.value[key])) {
                    filtersArr.push(
                        ...filters.value[key].map(el => {
                            const monthlyText = (key === 'monthlySales' && el[0] === 230000) ? 
                                'more than $230000' : 
                                el[0] === 0 ?  'less than $30000': `$${el[0]}-$${el[1]}`
                            return {
                                key: key,
                                text: key === 'category' ? el: monthlyText,
                                value: el
                            }
                        })
                    )
                }
                
            }
            return filtersArr
        })

        onMounted(() => {
            getList(userId, filters.value, 1)
        })

        watch(filters, filters => {
            page.value = 1
            getList(userId, filters, 1)
            sendDebouncedEvents()
        });

        const loadMore = () => {
            page.value++;
            getList(userId, filters.value, page.value)
            sendDebouncedEvents()
        }

        return {
            list,
            loadMore,
            filters,
            setFilter,
            resetFilters,
            filterItems,
            total,
            loading,
            openedFilters,
            emptyState
        }
    }

}
</script>

<style lang="scss" scoped>
.shops {
    &__text {
        margin: 0;
    }
    &__title {
        font-size: 24px;
        line-height: 32px;
        color: #000000;
    }
    &__description {
        font-size: 16px;
        line-height: 24px;
        color: #333333;
    }
}
[v-cloak] {
    display: none;
}
.shops__wrapper-emptystate {
    min-height: calc(100vh - 365px);
    display: flex;
    align-items: center;
    justify-content: center;
}
    .loading-holder {
        left: 0;
        right: 0
    }
</style>